module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shareModal"
  }, [_c('div', {
    staticClass: "shareImage"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImage()
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n     " + _vm._s(_vm.$t('shareTitle')) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ebb12e7!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Modals/Content/Share.vue
// module id = 162
// module chunks = 0